import React, {useState}  from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './home.css';
import './Sales.css';
import { Link,useNavigate } from 'react-router-dom';
import { MdKeyboardBackspace } from "react-icons/md";
import DataTable from 'react-data-table-component';
import { Buffer } from 'buffer';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import useFetch from '../Components/UseFetch';
import {salesOrders as SO} from '../HelperFx/datalinks';
import { addCommas } from '../HelperFx/common.js';

import verifyToken from '../HelperFx/verifyJwt.js';

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;

const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;


const eq = ' eq ';
const filter = '&$filter =';

const CustTable = () => {

  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName,userName, password} = verifyToken(jwttoken);

  // const customerLink = `${process.env.REACT_APP_API_URL}${customers}`; // Replace with the actual API URL
  const { data: salesOrders, loading, error } = useFetch(`${REACT_DATA_URL}${SO}?${REACT_APP_COMPANY_URL}${filter}customerNo${eq}'${custName}'`, token);
  // const { data: customer, loading, error } = useFetch(customerLink, token);
  const salesOrderInformation = salesOrders?.value;

  //Console.log(salesOrderInformation);

  const navigate = useNavigate();

  const data = salesOrderInformation || [];

  const [searchTerm, setSearchTerm] = useState('');

  //Console.log(data)

  const columns = [
    { name: 'No.',
      selector: row =>
      (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate(`/PurchaseOrder`, {state: {number: row.number, id: row.id}})}>
          {row.number}
        </span> 
      ),
      sortable: true },
    { name: 'Customer Name', selector: row => row.customerName, sortable: true },
    { name: 'Amount Local Currency', selector: row => addCommas(row.AmountLcy), sortable: true },
    { name: 'Currency', selector: row => row.currencyCode, sortable: true },
    { name: 'Email', selector: row => row.email, sortable: true },
  ];

  const filteredData = data.filter(item => 
    item.customerNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* <h3>Sales Orders</h3> */}
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='table-search'
      />

      <DataTable
        // title="Items List"
        columns={columns}
        data={filteredData}
        pagination
        customStyles={{
          rows: {
            style: {
              minHeight: '33px',
            },
          },
        }}
      />
    </div>
  );
};

const SalesOrders = () => {
  return (
    <div className="Home">
      <Nav/>
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
            <IconButton component={Link} to="/home">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <span>Purchase Orders</span>
            {/* <div className="actions">
              <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Attach</a>
              <a class="btn btn-sm border-black rounded-pill px-4 mx-2 action-btn" role="button" >Print</a>
            </div> */}
          </div>

          <div className="listTable">
            <CustTable/>
          </div>
        </div>
      </div>
      <Footer/>
  </div>
  )
}

export default SalesOrders